import { actionTypes } from "../reducers/SearchReducer";
import { queryStore } from "./UserActions";
import { selectPage } from "./TicketsActions";

export function search() {
  return (dispatch, getState) => {
    dispatch(_searching(true));
    // global states
    let state = getState();
    let searchStore = state.search;
    let ticketsStore = state.tickets;

    let storeQuery = searchStore.query;

    // used to fallback when some values are not provided
    let storeDefaultQuery = searchStore.default_query;

    // current page
    let page = ticketsStore.page;

    let searchQuery = {};

    if (storeQuery.CardStatusID.length > 0) {
      searchQuery.CardStatusID = {
        $in: storeQuery.CardStatusID
      };
    }

    if (storeQuery.CardTypeID.length > 0) {
      searchQuery.CardTypeID = {
        $in: storeQuery.CardTypeID
      };
    }

    if (storeQuery.ActionDate) {
      if (
        storeQuery.ActionDate.$gte &&
        storeQuery.ActionDate.$gte.length > 0
      ) {
        searchQuery.ActionDate = {
          ...searchQuery.ActionDate,
          $gte: storeQuery.ActionDate.$gte
        };
      }

      if (
        storeQuery.ActionDate.$lt &&
        storeQuery.ActionDate.$lt.length > 0
      ) {
        searchQuery.ActionDate = {
          ...searchQuery.ActionDate,
          $lt: storeQuery.ActionDate.$lt
        };
      }
    } else {
      searchQuery.ActionDate = storeDefaultQuery.ActionDate;
    }

    if (Object.entries(searchQuery).length > 0) {
      dispatch(queryStore(
        "v3_tickets",
        { nodeAuth: true, ...searchQuery },
        { per_page: 50, page }
      ))
      setTimeout(() => {
        dispatch(_searching(false))
      }, 2000);
    } else {
      console.log("nothing");
      dispatch(_searching(false));
    }
  };
}

export function updateSearchQuery(searchQuery) {
  return dispatch =>
    dispatch({
      type: actionTypes.UPDATE_SEARCH_QUERY,
      searchQuery
    });
}

/** HANDLERS */
function _searching(status) {
  return {
    type: actionTypes.SEARCHING,
    status
  }
}
